function collectionMain (){
  const gridModeCollection = (function () {
    return {
      init: function () {
        this.gridMode();
      },
      gridMode: function () {
        const _this = this
        document.addEventListener('click', function (e) {
          const el = e.target;
          const iconCol = el.classList.contains('action-col-prd');
          const btnShowFilter = el.classList.contains('btn-filter__innner');
          const btnCloseFilter = el.classList.contains('btn-close-filter__innner');
          const parnetFilter = el.closest('.facets-wrapper');

          if (iconCol) {
            const currentActive = el.closest('.action-col-prd-list').querySelector('.active')
            currentActive?.classList.remove('active');
            el.classList.add('active');
            const data_type = el.dataset.type;
            _this.setColGrid(data_type);

          }
          if (btnShowFilter) {
            _this.showFilter(el)
          }
          if (btnCloseFilter || !btnShowFilter && !parnetFilter) {
            _this.closeFilter(el)
          }
        });

        if (innerWidth <= 767) {
          _this.setColGrid(2);
        }

      },
      setColGrid: function (data_type) {
        const collection = document.querySelector('.tp-grid.product-grid');
        if (!collection) return;
        const classValue = `tp-grid product-grid tp-grid--${data_type}-col-desktop tp-grid--2-col-mobile list-none`;
        collection.setAttribute('class', classValue);
        let updateData = {
          attributes: {
            collection_products_column_show: parseInt(data_type),
          },
        };
        fetch(window.Shopify.routes.root + "cart/update.js", {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(updateData),
        })
            .then((res) => res.json())
            .then((data) => {
            })
            .catch(function (error) {
              console.error("Request failed", error);
            });
      },
      showFilter: function (el) {
        const body_overlay = document.querySelector('.tp-close-overlay');
        const parentCollection = el.closest('.tp-main-clc');
        const mainFilter = parentCollection.querySelector('.facets-wrapper');
        mainFilter?.classList.add('show-facets-wrapper');
        body_overlay.classList.add('is--visible');
      },
      closeFilter: function () {
        const body_overlay = document.querySelector('.tp-close-overlay');
        const mainFilter = document.querySelector('.facets-wrapper');
        mainFilter?.classList.remove('show-facets-wrapper');
        body_overlay.classList.remove('is--visible');
      }

    }
  })()

  const descriptionCollection = (function () {
    return {
      init: function () {
        this.clickBtnDesc();
      },
      clickBtnDesc: function () {
        const btnDesc = document.querySelector('.pdp_view_description_button');
        if (!btnDesc) return;
        document.addEventListener('click', function (e) {
          if (e.target.classList.contains('pdp_view_description_button')) {
            if (e.target.getAttribute('data-view') === "more") {
              document.querySelector('.desc-content').classList.add('open');
              document.querySelector('.pdp_view_description_button[data-view="less"]').classList.remove('hidden');
              e.target.classList.add('hidden');
            }
            if (e.target.getAttribute('data-view') === "less") {
              document.querySelector('.desc-content').classList.remove('open');
              document.querySelector('.pdp_view_description_button[data-view="more"]').classList.remove('hidden');
              e.target.classList.add('hidden');
            }
          }
        });
      }
    }
  })()


  const loadMoreCollection = (function () {
    return {
      init: function () {
        this.loadMorePrd();
      },
      loadMorePrd: function () {
        const _this = this;
        const productGrid = document.querySelector("#product-grid");
        if (!productGrid) return;
        _this.clickLoadMore();
        _this.scrollLoadMore()
      },
      clickLoadMore: function () {
        const _this = this;
        document.addEventListener("click", function (e) {
          if (e.target.classList.contains("load-more_btn")) {
            const loadmoreButton = document.querySelector("#loadmore-collection");
            if (loadmoreButton) {
              const dataLoadMoreType = loadmoreButton.getAttribute("data-type");
              const load_more_btn = document.querySelector(".load-more_btn");
              if (dataLoadMoreType === "click") {
                _this.loadMoreProducts(loadmoreButton, load_more_btn);
              }
            }
          }
        });
      },
      scrollLoadMore: function () {
        const _this = this;
        window.addEventListener("scroll", function (e) {
          const loadmoreButton = document.querySelector("#loadmore-collection");
          if (loadmoreButton) {
            const dataLoadMoreType = loadmoreButton.getAttribute("data-type");
            const load_more_btn = document.querySelector(".load-more_btn");
            if (dataLoadMoreType == "scroll") {
              var position = loadmoreButton.getBoundingClientRect();
              if (
                  position.top >= 0 &&
                  position.bottom <= window.innerHeight &&
                  !loadmoreButton.getAttribute("loading")
              ) {
                _this.loadMoreProducts(loadmoreButton, load_more_btn);
              }
            }
          }
        });
      },
      loadMoreProducts: function (loadmoreButton, load_more_btn) {
        const productGridDOM = document.querySelector("#product-grid");
        if (!productGridDOM || !loadmoreButton) return;

        const dataUrlNextCurrent = productGridDOM.getAttribute("data-url");
        if (!dataUrlNextCurrent) {
          loadmoreButton.removeAttribute("loading");
          if (load_more_btn) load_more_btn.style.display = "none";
          const wrap = loadmoreButton.closest(".load-more_wrap");
          if (wrap) wrap.style.display = "none";
          return;
        }

        loadmoreButton.setAttribute("loading", "true");
        fetch(dataUrlNextCurrent)
          .then((res) => res.text())
          .then((data) => {
            const parser = new DOMParser();
            const dataNextDOM = parser.parseFromString(data, "text/html");
            const productgridDataNextDOM = dataNextDOM.querySelector("#product-grid");
            if (!productgridDataNextDOM) {
              throw new Error("Load more: #product-grid missing in response");
            }

            const newProductItems = productgridDataNextDOM.querySelectorAll(".tp-grid__item");
            const loadMoreAmountDoc = document.querySelector(".load-more-amount");
            const loadMorePercent = document.querySelector(".load-more-percent");
            if (loadMoreAmountDoc) {
              loadMoreAmountDoc.innerHTML = dataNextDOM.querySelector(".load-more-amount")
                ? dataNextDOM.querySelector(".load-more-amount").textContent
                : "";
            }
            if (loadMorePercent) {
              const nextPercent = dataNextDOM.querySelector(".load-more-percent");
              if (nextPercent) loadMorePercent.style.width = nextPercent.style.width;
            }

            if (newProductItems.length > 0) {
              newProductItems.forEach((item) => {
                productGridDOM.appendChild(item);
              });
            }

            const nextUrl = productgridDataNextDOM.getAttribute("data-url");
            if (!nextUrl) {
              productGridDOM.removeAttribute("data-url");
              if (load_more_btn) load_more_btn.style.display = "none";
              const wrap = loadmoreButton.closest(".load-more_wrap");
              if (wrap) wrap.style.display = "none";
            } else {
              productGridDOM.setAttribute("data-url", nextUrl);
            }
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            loadmoreButton.removeAttribute("loading");
            try {
              if (window.tpCountdownTimer && typeof window.tpCountdownTimer.init === "function") {
                window.tpCountdownTimer.init();
              }
              if (
                window.tpColorSwatchesShopify &&
                typeof window.tpColorSwatchesShopify.init === "function"
              ) {
                window.tpColorSwatchesShopify.init();
              }
            } catch (e) {
              console.log(e);
            }
          });
      }
    }
  })()

  gridModeCollection.init();
  descriptionCollection.init();
  loadMoreCollection.init();
}

collectionMain()


document.addEventListener("shopify:section:load", collectionMain);
document.addEventListener("shopify:section:unload", collectionMain);
